export default __webpack_public_path__ + "static/P_SearchThumb_MotionDetector-e2996891e6f43f7204ab340e0e8bbe99.webp";